<template>
    <div class="DshUnit">
        <template v-if="formItem._type === 'index'">
            <span>{{ rowIndex + 1 }}</span>
        </template>

        <template v-else-if="formItem.render">
            <dsh-td-render
                :column="formItem"
                :row="formData"
                :index="rowIndex"
                :render="formItem.render"
            ></dsh-td-render>
        </template>

        <template v-else>
            <component
                :is="componentNameMap[formItem._type]"
                :mode="mode"
                :isShare="isShare"
                :canEdit="canEdit"
                :value="formData"
                :propsObj="{
                    ...formItem,
                    size: 'default',
                    inTable: true
                }"
                @change="change"
            ></component>
        </template>
    </div>
</template>

<script>
    import unitMixin from "./unitMixin.js";

    export default {
        name: "DshUnit",
        mixins: [unitMixin],
        props: {
            rowIndex: Number,
            isShare: Boolean
        },
        data () {
            return {};
        },
        computed: {},
        created () {},
        methods: {}
    };
</script>

<style lang="less" scoped>
    .DshUnit {}
</style>
<style lang="less">
    .DshUnit {
        .ivu-input {
            font-size: 12px;
        }
    }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/unit/DshUnit.vue